module.exports = __webpack_public_path__ + "static/media/noclass14.04a1d445.png";